import React from 'react';
import MessageList from './MessageList';

import { gameStateManager } from '../../App';
import { getPlayerConsoleIconPath } from '../../env'

class GameInfoConsole extends React.Component
{
  state = {
    messages: []
  };

  componentDidMount()
  {
    gameStateManager.addOnGameInfoConsoleMessageCallback( this.onGameInfoConsoleMessageCallback );
  }

  componentWillUnmount()
  {
    gameStateManager.removeOnGameInfoConsoleMessageCallback( this.onGameInfoConsoleMessageCallback );
  }

  onGameInfoConsoleMessageCallback = ( messageData ) =>
  {
    if( typeof messageData.playerIconID !== 'undefined' )
    {
      // console.log("messageData : ", messageData);

      messageData.messageIconPath = getPlayerConsoleIconPath( messageData.playerIconID, messageData.teamColourID );

      delete messageData.playerIconID;
    }

    this.setState( state => ( { messages: [ ...state.messages, messageData ] } ) );
  };

  render()
  {
    const { messages } = this.state;

    const
      {
        width,
        height,
        top,
        right
      } = this.props;

    return (
      <MessageList
        messages={ messages }
        classNamesPrefix="game-info-console"
        style={ {
          width: width + "px",
          height: height + "px",
          top: top + "px",
          right: right + "px",
        } }
      />
    );
  }
}

export default GameInfoConsole;
